angular.module('mtic.components.modules', [
      'ngPostMessage',
      'pixi',

      'mtic.components.mtic_resource',

      'mtic.components.modules.qcModule',
      'mtic.components.modules.learningMap',
      'mtic.components.modules.gr78',
      'mtic.components.modules.bubbleModule',
      'mtic.components.modules.c3',
      'mtic.components.modules.moduleIframe',
      'mtic.components.modules.c4',
      'mtic.components.modules.generalModuleMap'
])


angular.module('mtic.components.modules').directive('mticModules', function ($log, preliveCheck, api, EventManager, language, WindowOpener, TeacherDataService,$timeout,MapStateService,$q,userAccount, $sce, PlatformService, cordovaMessenger) {
      return {
            templateUrl: "template.html",
            scope: {
                  'moduleMapData': '=module'
            },
            link: function (scope) {
                  scope.isPrelive = preliveCheck.isPreliveCheck();
                  TeacherDataService.isTeacherWorkspaceView = false;
                  var eventManager = new EventManager("mticModules", scope);
                  var isExternalLink = function(resource) {
                    return (resource && resource.content) ? resource.content.container === 'link' : false;
                  }
                  scope.windowId = 'loadedResource';
                  if(scope.moduleMapData && MapStateService.getModuleModalsInvertedVisibility(scope.moduleMapData.resource_slug)){
                        scope.modalHidden = true;
                  }else{
                        scope.modalHidden = false;
                  }

                  scope.hideModal = function(is_gr78){
                    if(is_gr78){
                      scope.modal2Hidden = true;
                    }else{
                        scope.modalHidden = true;
                    }
                    MapStateService.setModuleModalsInvertedVisibility(scope.moduleMapData.resource_slug,true);
                  }

                  var noclass_items = [1236, 1240, 1244, 1248];
                  eventManager.listen('module:open:resource', function (e, currentResource) {
                    if(isExternalLink(currentResource)){
                      WindowOpener.open(currentResource.hostUrl, scope.windowId)
                    }
                    if(currentResource.url || noclass_items.indexOf(currentResource.id) > -1 || currentResource.resource_type === 'embedded_notification'){
                          return;
                    }
                    scope.currentResource = currentResource;
                  })
                  eventManager.listen('module:close:resource', function (e, args) {
                    if (!(args && args.isPassive)){
                        delete scope.currentResource;
                        if(!args){
                          eventManager.broadcast('app:module:open')
                        }
                    }
                  })

                  var updateCounter = 0;
                  var updateCurrentModule = function(moduleMapData){
                        delete scope.currentResource;
                        scope.currentModule = moduleMapData.resource_slug;
                        scope.noModule = false;
                        updateCounter = 0;
                        //manually clean route names if not in workspace view
                        if(!TeacherDataService.isTeacherWorkspaceView)
                        {
                              eventManager.broadcast('update:resource:slug:route:name',{slug:"",name:""});
                              eventManager.broadcast("hide:back:arrow");
                              eventManager.broadcast("hide:back:module:arrow");
                              eventManager.broadcast('update:submodule:slug:route:name',{slug:"",name:""});
                        }
                  }

                  scope.$watch('moduleMapData', function(moduleMapData){
                        $log.debug('[[mticModules]] INIT', moduleMapData)
                        updateCounter ++ ;
                        if(moduleMapData) {
                              $timeout(function(){
                                    if(scope.currentResource && scope.currentResource.slug.indexOf('mtic_c3_m56_') > -1 && !userAccount.getData().role.isTeacher) //(scope.currentModule && scope.currentModule.indexOf('_m56_') > -1)
                                    {
                                      var defer = $q.defer();
                                      eventManager.broadcast('module:updateAndClose:resource',defer);
                                      defer.promise.then(function(){
                                          updateCurrentModule(moduleMapData);
                                      });
                                    }
                                    else{
                                          updateCurrentModule(moduleMapData);
                                    }
                              });

                        }else if(updateCounter > 2){
                              scope.noModule = true;
                        }
                  });

                  eventManager.listen('open:custom:resource', function(e, data){
                        $log.log('got open custom request : ', data)
                        var modified_url = data.url.indexOf('http') === -1 ? 'https://'+data.url : data.url;
                        if (PlatformService.isApp){
                            cordovaMessenger.postToCordova('openPdfLink', { pdfUrl: modified_url });
                        }else{
                            window.open(modified_url , '_blank');
                        }
                        //scope.custom_resource_url = data.url;
                        //scope.currentModule = 'custom_resource';
                        //eventManager.broadcast('module:open:resource', data)
                        var user_data = userAccount.getData();
                        var stateUpdate = {
                          "slug": data.slug,
                          "score": 1,
                          "complete": true,
                          "time_spent": 0,
                          "time_stamp": Date.now(),
                          "resource_id": data.id,
                          "module_id": scope.moduleMapData.module_id,
                          "component_instances": {},
                          "app_state": {},
                          "log_data": {},
                          "class_id": userAccount.getActiveClassroom()
                        }
                        api.submitStudentResourceState(stateUpdate).then(function (response) {
                          eventManager.broadcast('refresh-agenda-sidepanel', data)
                              // $log.log('response : ', response)
                          //eventManager.broadcast('navbar:seen_info_popup')
                        })
                  })

                  scope.trustSrc = function(src) {
                        return $sce.trustAsResourceUrl(src);
                  }
                  scope.get_translation = function(slug){
                       return language.get(slug);
                  }
                  scope.hide_maintenance_msg = function(){
                        scope.item_maintenance = false;
                        scope.itemMaintenanceMsgHidden = true;
                  }
                  eventManager.listen('display-maintenance-message', function(e, slug){
                        scope.itemMaintenanceMsgHidden = false;
                        scope.item_maintenance = true;
                        scope.current_item = slug
                  })
                  eventManager.listen('request-next-item', function(e, slug){
                        $log.log('got item request : ', slug)
                        var found_resources = [];
                        _.each(scope.moduleMapData.resources, function(submod){
                              if(submod.children){
                                    _.each(submod.children, function(item){
                                          if(item.unlocked_by.indexOf(slug) > -1 && !(item.config && item.config.assessment_type)){
                                                found_resources.push(item); 
                                          }
                                    })
                              }
                        })
                        $log.log('found item request : ', found_resources);
                        MapStateService.setNextAvailableItem(found_resources.length === 1 ? found_resources[0] : null);
                        //eventManager.broadcast('response-next-item', found_resources[0].slug)
                  });
                  scope.get_item_maintenance_message = function(){
                        var txt = language.getCurrentSelectedLanguage() === 'en' ? ' is under maintenance.' : ' en maintenance.'
                        return  language.get(scope.current_item) + txt
                  }

                  // Mobile View
                  scope.mModuleView = {LIST: 'module-list-view', MAP: 'module-map-view'};
                  scope.mSelectedModuleView = scope.mModuleView.MAP;
                  scope.mToggleModuleView = function(e){
                    if(!e.srcElement.classList.contains('module-view-icon') && !e.srcElement.classList.contains('text-toggle')){
                      e.preventDefault();
                      e.stopImmediatePropagation();
                      return;
                    }
                    scope.mSelectedModuleView = (scope.mSelectedModuleView === scope.mModuleView.LIST) ? scope.mModuleView.MAP : scope.mModuleView.LIST;
                  }
                  scope.$watch('mSelectedModuleView', function(view){
                    window.console.warn('mSelectedModuleView: ' + view);
                  });
                  // End of Mobile View
            }
      }
})
